import { say } from "../../localization/say.ts";
import { calledBy } from "../../me/called.ts";
import type { Reaction, Reactor } from "./reacting.ts";

export const NAMES_BEFORE_A_COUNT = 3;

export const NAMES_IN_FULL = 4;

export function reactorsInOrder(who: readonly Reactor[]): Reactor[] {
  return [...who.filter((one) => one.you), ...who.filter((one) => !one.you)];
}

export function nameOf(one: Reactor): string {
  return one.you ? say("react.you") : (calledBy(one) ?? say("chat.someone"));
}

export function namesOn(reaction: Reaction): string[] {
  const named = reactorsInOrder(reaction.who).map(nameOf);

  if (reaction.mine && !reaction.who.some((one) => one.you)) named.unshift(say("react.you"));
  while (named.length < reaction.count) named.push(say("chat.someone"));
  return named.slice(0, Math.max(reaction.count, 1));
}

export function saidBy(names: readonly string[]): string {
  if (names.length === 0) return "";
  if (names.length === 1) return names[0] as string;
  if (names.length <= NAMES_IN_FULL) {
    const last = names[names.length - 1] as string;
    return say("react.andLast")(names.slice(0, -1).join(say("react.between")), last);
  }
  const first = names.slice(0, NAMES_BEFORE_A_COUNT).join(say("react.between"));
  return say("react.andOthers")(first, names.length - NAMES_BEFORE_A_COUNT);
}

export function allSaidBy(names: readonly string[]): string {
  if (names.length === 0) return "";
  if (names.length === 1) return names[0] as string;
  const last = names[names.length - 1] as string;
  return say("react.andLast")(names.slice(0, -1).join(say("react.between")), last);
}

export function whoReacted(reaction: Reaction): string {
  return saidBy(namesOn(reaction));
}

export function everyoneWhoReacted(reaction: Reaction): string {
  return allSaidBy(namesOn(reaction));
}
